import {
    formatAsUserLongDate,
    formatAsUserLongDateTime,
    formatAsUserShortDate,
    formatAsUserShortDateTime
} from '~/modules/helpers/date';

export const userLongDateFormatter = params =>
    formatAsUserLongDate(params?.value);

export const userLongDateTimeFormatter = params =>
    formatAsUserLongDateTime(params?.value);

export const userShortDateFormatter = params =>
    formatAsUserShortDate(params?.value);

export const userShortDateTimeFormatter = params =>
    formatAsUserShortDateTime(params?.value);
